module.exports = __webpack_public_path__ + "static/media/IMG-20200108-WA0014.d2104e06.jpg";